import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter } from '../data/tenantDomainMap';

export function createTenantDomainMapService(client: AxiosInstance) {
  return createCrudService<TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter>(
    client,
    '/TenantDomainMap',
    'tenantDomainMapId'
  );
}

export type TenantDomainMapService = CrudService<
  TenantDomainMap,
  TenantDomainMapCreate,
  TenantDomainMapFilter
>;
